<!-- 对方人员设置委托 -->
<template>
    <div>
        <!-- <subComponents  ref="showSelectData"></subComponents> -->
        <el-dialog :visible.sync="dataActionBox.showStatus" :title="dataActionBox.boxTitle" append-to-body :close-on-click-modal="false" center width="80%" top="1rem">
            <el-form @submit.native.prevent class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                <el-row>
                    <template v-for="(formOneValue, formOneKey) in formDataList">
                        <el-form-item v-if="formOneValue.isShow==1&&formOneValue.entityField!='terType'&&formOneValue.entityField!='filePath'" :key="formOneKey" :id="formOneValue.entityField" :label="formOneValue.showField"
                                      :prop="formOneValue.entityField" :rules="formOneValue.isRequired == 1 ? [{ required: true, trigger: ['blur', 'change'] }] : []">
                            <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                            <!-- 地域限制 -->
                            <el-select v-if="formOneValue.entityField=='geogRest'" :disabled="formOneValue.isChange==0" v-model="sendDataInfo.geogRest" style="width: 100%;" clearable>
                                <el-option v-for="(values) in geogRestData" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                            </el-select>
                            <!-- 委托书名称 -->
                            <el-select v-else-if="formOneValue.entityField=='terName'" :disabled="formOneValue.isChange==0" v-model="sendDataInfo.terName" style="width: 100%;" clearable>
                                <el-option v-for="(values) in dictionariesDatas" :key="values.diId" :label="values.diName" :value="values.diValue"></el-option>
                            </el-select>
                            <!-- 是否拦截 -->
                            <el-radio-group v-else-if="formOneValue.entityField=='isIntercept'" v-model="sendDataInfo.isIntercept" :disabled="formOneValue.isChange==0">
                                <el-radio-button :label="matItem.key" v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key">{{matItem.value}}</el-radio-button>
                            </el-radio-group>
                            <!-- 是否使用 -->
                            <el-radio-group v-else-if="formOneValue.entityField=='isUsed'" v-model="sendDataInfo.isUsed" :disabled="formOneValue.isChange==0">
                                <el-radio-button :label="matItem.key" v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key">{{matItem.value}}</el-radio-button>
                            </el-radio-group>
                            <el-select v-else-if="formOneValue.entityField=='terScope'" :disabled="formOneValue.isChange==0||sendDataInfo.terType==1" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;"
                                       clearable>
                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.value" :value="matItem.key"></el-option>
                            </el-select>
                            <el-select v-else-if="formOneValue.fieldType=='formatter'" :disabled="formOneValue.isChange==0" v-model="sendDataInfo[formOneValue.entityField]" style="width: 100%;" clearable>
                                <el-option v-for="matItem in JSON.parse(formOneValue.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value"></el-option>
                            </el-select>
                            <!-- 身份证号 -->
                            <el-input v-else-if="formOneValue.entityField=='salesNumber'" :disabled="formOneValue.isChange==0" v-model.trim="sendDataInfo.salesNumber">
                                <template slot="append"><span
                                          style="color: red;">{{sendDataInfo.salesNumber== '' ||sendDataInfo.salesNumber == null ||sendDataInfo.salesNumber == undefined ? 0 :sendDataInfo.salesNumber.length }}位</span></template>
                            </el-input>
                            <!-- 身份证有效期 -->
                            <df-date v-else-if="formOneValue.entityField=='numberValidity'" :disabled="formOneValue.isChange==0" v-model="sendDataInfo.numberValidity" :isType="true">
                            </df-date>
                            <!-- 委托书有效期 -->
                            <df-date v-else-if="formOneValue.entityField=='terValidity'" v-model="sendDataInfo.terValidity" :isType="true"></df-date>
                            <!-- 业务员备注 -->
                            <el-input v-else-if="formOneValue.entityField=='remark'" :disabled="formOneValue.isChange==0" v-model="sendDataInfo.remark" style="width: 100%;" type="textarea" clearable
                                      maxlength="200"></el-input>
                            <el-input v-else :disabled="formOneValue.isChange==0" v-model.trim="sendDataInfo[formOneValue.entityField]"></el-input>
                        </el-form-item>
                    </template>
                </el-row>
                <el-row>
                    <el-col>
                        <el-form-item class="elTable" label="委托书类型">
                            <label slot="label" :style="$common.labelStyle('委托书类型')" v-html="'委托书类型'"></label>
                            <div>
                                <el-radio-group v-model="sendDataInfo.terType" @change="changeTerType">
                                    <el-radio-button label="1">单品委托</el-radio-button>
                                    <el-radio-button label="0">全品委托</el-radio-button>
                                </el-radio-group>
                            </div>
                            <div v-if="sendDataInfo.terType == 1">
                                <div style="margin:.6rem 0">
                                    <el-button type="primary" size="mini" @click="openSearch('853533363572736')">新增单品
                                    </el-button>
                                    <el-button type="primary" size="mini" @click="delLicense()">删除单品</el-button>
                                </div>
                                <el-table :data="sendDataInfo.descibSalesplicencedetailVo" height="220" border style="width: 100%" size="mini">
                                    <el-table-column label="选择操作" width="80">
                                        <template slot-scope="scope">
                                            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                                                <i class="el-icon-thumb"></i>
                                            </el-radio>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="bgmName" label="通用名称" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="mne" label="助记码" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="spec" label="规格" show-overflow-tooltip></el-table-column>
                                    <el-table-column prop="manufacturer" label="生产厂商" show-overflow-tooltip>
                                    </el-table-column>
                                    <el-table-column prop="placeorigin" label="产地" show-overflow-tooltip>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-form-item label="委托书图片">
                        <div style="display: flex;align-items: center;">
                            <input style="display: none;" type="file" id="salesUpdata" accept="image/*" multiple name="salesUpdata" @change="(e) => { fileUpload(e.target.files, e.target.files.length, 0, e) }" />
                            <label for="salesUpdata" class="image_label">上传</label>
                            <el-button @click.stop="openFile1()" type="primary" size="mini">高拍仪</el-button>
                        </div>
                        <div style="margin-top: 10px;">
                            <ul class="uploadList" v-if="sendDataInfo.filePath">
                                <li v-for="(val, key) in sendDataInfo.filePath.split(',')" :key="key" class="image">
                                    <i class="el-icon-error del" @click="delRemove(key)"></i>
                                    <cusImage style="width: 60px; height: 60px;margin-top: 5px;" :src="`${imgUrl}/${val}`" :preview-src-list="[`${imgUrl}/${val}`]">
                                    </cusImage>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="initActionBox">取消</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 0">保存</el-button>
                <el-button type="primary" @click="sendDataAction('sendDataInfo')" v-if="dataActionBox.actionType == 1">保存</el-button>
            </div>
        </el-dialog>
        <!-- 检索方案弹窗 -->
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true">
            <SearchSchemeMultiple ref="searchSchemeMultiple" :id="seId" :parentData="parentData" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
            <span slot="footer" class="dialog-footer">
                <el-button @click="DialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="getSelect">确认选择</el-button>
            </span>
        </el-dialog>
        <FileNewAction ref="FileNewAction" v-if="showFile" :showFile="showFile" @isshowFile="IsshowFile" @NewelectFileIds="changeFileIds"></FileNewAction>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../byComponents/SearchScheme.vue";
import searchSchemeMultiple from "../byComponents/SearchSchemeMultiple.vue";
export default {
    name: "salesSettingUnitForm",
    props: [],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        searchSchemeMultiple,
    },
    data() {
        //这里存放数据
        return {
            token: {
                token: sessionStorage.getItem("token"),
            },
            dataActionBox: {
                showStatus: false,
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {
                salesId: "", //对方业务员id
                salesName: "",//业务员名称
                salesMne: "",//助记码
                salesSex: "",//性别
                geogRest: "",//地域
                phone: "",//电话
                salesNumber: "",//身份证号
                numberValidity: "",//身份证效期
                bgmIds: [], //单品明细
                terValidity: "", //日期
                isIntercept: 1, //是否拦截
                terType: 0, //委托类型
                filePath: '', //图片地址
                terName: "", //委托名
                isUsed: 1, //是否使用
                descibSalesplicencedetailVo: [],
                terScope: 0, //委托范围
                remark: "", //备注
                // contractRemark: "",//委托书备注
            },
            seTitle: "", //检索
            DialogVisible: false,
            seWidth: "0",
            seId: 0,
            selectedDataIndex: 0, //单品选择索引
            dictionariesDatas: [],
            requesUrl: "",
            imgUrl: "",
            showFile: false,
            parentData: {
                type: "bgmId",
                list: [],
            },
            geogRestData: [],//地域
            parentSearchData: {},
            //----------------------------
            showDialog: false,
            dialogList: [],
            //----------------
            formDataList: [],//动态表单
            lastSendData: null,//上一次保存成功的委托数据（新增带出用）
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.salesName": function (newValue, old) {
            this.sendDataInfo.salesMne = this.$common.createPinyinCode(
                this.sendDataInfo.salesName,
                this.sendDataInfo.salesMne
            );
        },
    },
    //方法集合
    methods: {
        changeTerType() {
            if (this.sendDataInfo.terType == 1) {
                this.sendDataInfo.terScope = 0
            }
        },
        //获取性别
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [1, 44],
            });
            if (responseData.status == 200) {
                this.geogRestData = responseData.result.dyxz;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        openFile1() {//打开高拍仪组件
            this.showFile = true
        },
        IsshowFile(value) {
            this.showFile = value
        },
        changeFileIds(val) {
            var arr = []
            if (this.sendDataInfo.filePath) {
                arr = this.sendDataInfo.filePath.split(",")
            }
            val.forEach(item => {
                arr.push(item.fileUrl)
            })
            this.sendDataInfo.filePath = arr.join()
            this.showFile = false
            this.$forceUpdate()
        },
        //
        getSelect() {
            var mx = JSON.parse(JSON.stringify(this.$refs.searchSchemeMultiple.multipleSelection))
            this.sendDataInfo.descibSalesplicencedetailVo = mx
            this.DialogVisible = false;
        },
        delRemove(key) {
            var arr = this.sendDataInfo.filePath.split(",")
            arr.splice(key, 1)
            this.sendDataInfo.filePath = arr.join()
        },
        async fileUpload(files, length, index, e) {
            if (length - 1 >= index) {
                const params = {
                    file: files[index]
                }
                const response = await this.$http.uploadFile(params, true)
                console.log(response);
                if (response.status == 200) {
                    var arr = []
                    if (this.sendDataInfo.filePath) {
                        arr = this.sendDataInfo.filePath.split(",")
                    }
                    arr.push(response.result[0].fileUrl)
                    this.sendDataInfo.filePath = arr.join()
                    this.fileUpload(files, length, index + 1, e)
                } else {
                    e.target.value = ""
                    this.$message.error(response.message)
                }
            } else {
                e.target.value = ""
            }
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId) {
            this.DialogVisible = true;
            this.seId = sId;
            if (this.sendDataInfo.descibSalesplicencedetailVo != null && this.sendDataInfo.descibSalesplicencedetailVo.length > 0) {
                this.parentData.list = this.sendDataInfo.descibSalesplicencedetailVo
            }
        },
        //检索带回数据
        changeInputModel(val) {
            console.log("返hui", val);
            if (val != "" || val != undefined) {
                //检测重复
                console.log(this.sendDataInfo.descibSalesplicencedetailVo)
                for (let i = 0; i < this.sendDataInfo.descibSalesplicencedetailVo.length; i++) {
                    const element = this.sendDataInfo.descibSalesplicencedetailVo[i];
                    if (val.bgmId == element.bgmId) {
                        this.$message({
                            message: "当单品已存在，请选择其它商品",
                            type: "error",
                        });
                        return false;
                    }
                }
                this.DialogVisible = false; //关闭商品检索窗口
                //赋值
                this.sendDataInfo.descibSalesplicencedetailVo.push(val)

            } else {
                this.DialogVisible = false;
                this.$message({
                    message: "检索失败",
                    type: "error",
                });
            }
            console.log("检索返后", this.sendDataInfo);
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },

        //新增委托
        sendDataAction(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    if (this.sendDataInfo.terName == "") {
                        this.$message({
                            message: "请填写委托书名称",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.sendDataInfo.terType == 0) {
                        //全品不需要明细
                        this.sendDataInfo.descibSalesplicencedetailVo = [];
                    }

                    if (
                        this.sendDataInfo.terType == 1 &&
                        this.sendDataInfo.descibSalesplicencedetailVo.length < 1
                    ) {
                        this.$message({
                            message: "请添加单品商品",
                            type: "error",
                        });
                        return false;
                    }
                    if (this.sendDataInfo.terType == 0) {
                        this.sendDataInfo.descibSalesplicencedetailVo = []
                    }
                    var filePath = []
                    if (this.sendDataInfo.filePath != undefined && this.sendDataInfo.filePath != null && this.sendDataInfo.filePath != "") {
                        filePath = this.sendDataInfo.filePath.split(',')
                    }
                    this.$http.fromruleCheckSalsesFile({ filePaths: filePath }).then(res => {
                        if (res.status == 200 || res.status == 200) {
                            let flag = -1;
                            this.dialogList = []
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                //保存成功前记录数据快照，供下次新增带出
                                this.lastSendData = JSON.parse(JSON.stringify(this.sendDataInfo));
                                this.$parent.pushData(this.sendDataInfo, this.dataActionBox.actionType)
                                this.dataActionBox.showStatus = false
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.$message.error(res.message)
                        }
                    })

                } else {
                    this.$message({
                        message: "请完善必填信息",
                        type: "error",
                    });
                    return false;
                }
            });
        },

        //删除单品
        delLicense() {
            if (this.sendDataInfo.descibSalesplicencedetailVo.length < 1) {
                this.$message({
                    message: "请先添加单品",
                    type: "error",
                });
                return false;
            }
            this.sendDataInfo.descibSalesplicencedetailVo.splice(this.selectedDataIndex, 1);
            this.sendDataInfo.bgmIds.splice(this.selectedDataIndex, 1);
            this.selectedDataIndex = 0;
        },
        //上传图片
        uploadFileAction() {
            this.$refs.fileInput.click();
        },

        //取消新增
        initActionBox() {
            this.dataActionBox.showStatus = false;
            this.init();
            this.$refs['sendDataInfo'].resetFields();

        },
        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                this.sendDataInfo[key] = "";
            }
            this.sendDataInfo.isIntercept = 1;
            this.sendDataInfo.terScope = 0;
            this.sendDataInfo.terType = 0;
            this.sendDataInfo.isUsed = 1;
            this.sendDataInfo.descibSalesplicencedetailVo = [];
            this.sendDataInfo.filePath = ""
            this.sendDataInfo.bgmIds = [];
        },

        //父级传入
        openBox(cate, oldData = {}, type, formDataList) {
            this.formDataList = formDataList
            this.getPartDictionariesData()
            this.dataActionBox.actionType = cate;
            let oldData1 = JSON.parse(JSON.stringify(oldData));
            this.filterMainField();
            if (cate == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.showStatus = true;
                // 配置开启时，新增带出上一次保存的数据；否则保持清空状态
                if (window.global_config.salesUnitCarryLastData && this.lastSendData) {
                    for (let key in this.lastSendData) {
                        this.$set(this.sendDataInfo, key, this.lastSendData[key]);
                    }
                    this.selectedDataIndex = 0;
                }
            } else {
                this.dataActionBox.boxTitle = "编辑信息";
                this.$nextTick(() => {
                    for (let key in oldData1) {
                        console.log(key);
                        if (key == 'filePath') {
                            this.$set(this.sendDataInfo, key, oldData1[key])
                        } else {
                            this.$set(this.sendDataInfo, key, oldData1[key]);
                        }
                    }
                })

                if (this.sendDataInfo.descibSalesplicencedetailVo == null) {
                    this.sendDataInfo.descibSalesplicencedetailVo = []
                }
                this.dataActionBox.showStatus = true;
            }
        },
        //获取委托书名称
        async getCateDictionariesDatas() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [45],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        imgur() {
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        filterMainField() {
            var obj = this.$common.filterMainFields([], [],{jurconfigform:this.formDataList})
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key])
            }
            this.sendDataInfo.isIntercept = 1;
            this.sendDataInfo.terType = 0;
            this.sendDataInfo.isUsed = 1;
            this.sendDataInfo.descibSalesplicencedetailVo = [];
            this.sendDataInfo.filePath = ""
            this.sendDataInfo.bgmIds = [];
            console.log(this.sendDataInfo,"测试");
            
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.imgur();
        this.getCateDictionariesDatas()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() { },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
::v-deep .baseForm .elTable .el-form-item__content {
    width: 80% !important;
}
::v-deep .baseForm .el-form-item__content {
    width: 240px !important;
}
::v-deep .baseForm .el-form-item__content #dateinput {
    width: 240px !important;
}
::v-deep .baseForm .el-textarea__inner {
    width: 240px !important;
}
/* 图片上传样式 */
.uploadList {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 350px;
    list-style: none;
}

.image {
    position: relative;
    width: 65px;
    height: 65px;
    margin-right: 5px;
    margin-bottom: 5px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
}

.image:nth-child(5n) {
    margin-right: 0;
}

.del {
    display: none;
    position: absolute;
    top: 0px;
    right: 0px;
    font-size: 14px;
    z-index: 99;
    cursor: pointer;
}

.del:hover {
    color: #409eff;
}

.image:hover .del {
    display: inline-block;
}
.image_label {
    cursor: pointer;
    padding: 7px 10px !important;
    font-size: 12px !important;
    background-color: #409eff;
    color: #ffffff;
    line-height: 14px;
    margin-right: 5px;
    border-radius: 3px;
}

::v-deep .el-image__error {
    font-size: 7px;
}
::v-deep .cus-image {
    width: 60px !important;
    height: 60px !important;
}
</style>